import React from 'react';
import { css } from '@emotion/core';
import MoonLoader from 'react-spinners/MoonLoader';

const Spinner = (props) => {
  return <MoonLoader color="#ffffff" {...props} loading />;
};

export default Spinner;
